"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CalcBtn;
var jsx_runtime_1 = require("react/jsx-runtime");
var handlers_1 = require("../../../lib/handlers");
function CalcBtn(_a) {
    var group = _a.group, id = _a.id;
    return ((0, jsx_runtime_1.jsx)("button", { className: "btn btn-secondary calc-btn", "data-group": group, title: "Clique aqui para realizar os c\u00E1lculos para o grupo ".concat(group === "main" ? "geral" : group), id: "btn".concat(id), onClick: function (ev) {
            var _a, _b;
            return (0, handlers_1.calcKits)((_a = sessionStorage.getItem("v")) !== null && _a !== void 0 ? _a : "", (_b = ev.currentTarget.dataset.group) !== null && _b !== void 0 ? _b : "main");
        }, children: "Calcular" }));
}
